import { Configuration, Payload } from 'rollbar';
import { isEmpty } from 'lodash-es';
import packageConfig from './package.config';

export default {
  accessToken: process.env.ROLLBAR_TOKEN,
  captureUncaught: true,
  captureUnhandledRejections: true,
  enabled:
    !isEmpty(process.env.ENVIRONMENT) &&
    ['test', 'staging', 'production'].includes(process.env.ENVIRONMENT),
  payload: {
    environment: process.env.ENVIRONMENT,
    client: {
      javascript: {
        code_version: packageConfig.appVersion,
        source_map_enabled: true,
      },
    },
  } as Payload,
} as Configuration;
